import PageForm from 'components/pageForm/PageForm.js';
import BodyVivier from './components/content/body.vivier.js';

const Vivier = () => (
  <PageForm>
    <BodyVivier />
  </PageForm>
);

export default Vivier;
